import clsx from 'clsx'
import { type SelectHTMLAttributes, forwardRef } from 'react'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid, className, children, ...rest },
  ref,
) {
  return (
    <select
      ref={ref}
      aria-invalid={invalid || undefined}
      className={clsx(
        // Apple-style: white surface, hairline border, blue focus ring.
        'h-10 w-full rounded-[var(--radius)] border bg-[var(--bg)] px-3 pr-9 text-[14px] text-[var(--text)]',
        'outline-none transition-colors appearance-none',
        'focus-visible:shadow-[var(--focus-ring)] focus-visible:border-[var(--accent)]',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        invalid ? 'border-[var(--amber)]' : 'border-[var(--border)] hover:border-[var(--text-3)]',
        // Custom caret via background SVG (Apple gray-500)
        'bg-[length:14px] bg-[right_10px_center] bg-no-repeat',
        className,
      )}
      style={{
        backgroundImage:
          "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='%236e6e73' stroke-width='1.5'><path d='M4 6l4 4 4-4'/></svg>\")",
      }}
      {...rest}
    >
      {children}
    </select>
  )
})
